import React from 'react';
import CountUp from 'react-countup';
import { InfoOutlineIcon } from '@chakra-ui/icons';
import { Tooltip } from 'uie/components';

type MetricCardProps = {
  metricKey: string;
  metricData: {
    current: number;
    previous: number;
    percentChange: number;
  };
  persistDiff: number;
  tooltipContent?: string;
};

const MetricCard: React.FC<MetricCardProps> = ({
  metricKey,
  metricData,
  persistDiff,
  tooltipContent,
}) => {
  const diff = metricData.percentChange ?? 0;
  const isTimeMetric = metricKey === 'mtta' || metricKey === 'mttr';

  const getColorStyle = () => {
    const positiveIndicators: Array<string> = ['acknowledged', 'resolved', 'suppressed'];

    const isPositiveIndicator = positiveIndicators.includes(metricKey);

    if (diff === 0) return '#0f61dd';
    if (diff > 0) {
      return isPositiveIndicator ? '#15c26b' : '#f04546';
    }
    return isPositiveIndicator ? '#f04546' : '#15c26b';
  };

  return (
    <div
      className="metric-display float-left"
      style={{
        width: '16%',
        marginRight: '0.8%',
        padding: '20px 15px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex' }}>
        <div className="metric-display-image" style={{ marginRight: 15 }}>
          <img
            src={'/icons/' + metricKey + '.svg'}
            alt="number"
            style={{
              height: 49,
              width: 49,
              display: 'block',
              position: 'relative',
              top: 10,
            }}
          />
        </div>
        <div className="metric-display-text">
          <h1
            className="item-box-tagline font-bold"
            style={{
              margin: 0,
              marginBottom: 10,
              textTransform: isTimeMetric ? 'uppercase' : 'capitalize',
            }}
          >
            {metricKey}
            {tooltipContent && (
              <div style={{ textTransform: 'initial', display: 'inline' }}>
                <Tooltip
                  padding="8px"
                  offset={{
                    top: '-110px',
                    left: isTimeMetric && metricKey === 'mttr' ? '-200px' : '-50px',
                  }}
                  width="240px"
                  label={tooltipContent}
                >
                  &nbsp;
                  <InfoOutlineIcon w={10} h={10} mb={1} ml={1} />
                </Tooltip>
              </div>
            )}
          </h1>
          <div
            className="item-box-tagline"
            style={{
              fontSize: 24,
              margin: 0,
              marginBottom: 4,
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            <CountUp
              preserveValue={true}
              duration={0.8}
              decimals={isTimeMetric ? 2 : 0}
              start={metricData.previous}
              end={metricData.current}
            />

            {isTimeMetric && (
              <span
                style={{
                  fontSize: 14,
                  marginLeft: 2,
                  fontWeight: 600,
                }}
                className="item-box-tagline"
              >
                Hrs
              </span>
            )}
          </div>
          <div
            style={{
              margin: 0,
              color: getColorStyle(),
            }}
          >
            {diff === 0 ? null : (
              <i
                className={'fa fa-caret-' + (diff > 0 ? 'up' : 'down')}
                style={{ marginRight: 10 }}
              />
            )}
            {diff > 10000 ? (
              '>10000'
            ) : (
              <CountUp
                preserveValue={true}
                duration={0.8}
                decimals={diff % 1 !== 0 ? 2 : 0}
                start={persistDiff}
                end={diff}
              />
            )}
            %
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
